import httpRequest from './../../../../modules/Gull/Framework/httpRequest.js';
import gullActivatePreGeneratedAccount from './../../../Gull/Framework/Login/activatePreGeneratedAccount.js';

const activatePreGeneratedAccount = {
	/**
	 * Initialize the activate pre-generated account functionality
	 *
	 * @returns {void}
	 */
	init() {
		// Initialize the gullActivatePreGeneratedAccount module
		gullActivatePreGeneratedAccount.init();

		// Add event listener to the username input
		document.getElementById('username').addEventListener('change', activatePreGeneratedAccount.handleUsernameChange);
	},

	/**
	 * Handle username input changes and fetch group data if needed
	 *
	 * @param {Event} event - The change event
	 *
	 * @returns {void}
	 */
	handleUsernameChange(event) {
		const groupId = event.target.value.toUpperCase();
		activatePreGeneratedAccount.resetToestemmingsverklaring();
		if (activatePreGeneratedAccount.isValidGroupId(groupId)) {
			httpRequest.get(window.app.ajaxPath + 'nl/group/' + groupId, function (data) {
				data = JSON.parse(data);
				activatePreGeneratedAccount.updateCheckboxesFromGroupData(data);
			});
		}
	},

	/**
	 * Update checkboxes based on group data
	 *
	 * @param {Object} data - The group data containing checkbox values
	 *
	 * @returns {void}
	 */
	updateCheckboxesFromGroupData(data) {
		const element = document.querySelector('.toestemmingsverklaring');
		if (element.classList.contains('d-none')) {
			element.classList.remove('d-none');
		}
		Object.entries(data).forEach(([key, item]) => {
			const checkbox = document.getElementById('toestemming-' + key + '-checkbox');
			if (checkbox && item !== '') {
				checkbox.checked = true;
			}
		});
	},

	/**
	 * Reset the toestemmingsverklaring section by hiding it and unchecking all checkboxes
	 *
	 * @returns {void}
	 */
	resetToestemmingsverklaring() {
		const element = document.querySelector('.toestemmingsverklaring');
		if (!element.classList.contains('d-none')) {
			element.classList.add('d-none');
		}
		document.querySelectorAll('.toestemmingsverklaring input[type=checkbox]').forEach((checkbox) => (checkbox.checked = false));
	},

	/**
	 * Check if the group ID is valid for fetching data
	 *
	 * @param {string} groupId - The group ID to validate
	 *
	 * @returns {boolean}
	 */
	isValidGroupId(groupId) {
		return groupId.charAt(0) === 'R' && groupId.length > 6;
	},
};

export default activatePreGeneratedAccount;
